<template>
  <v-container>
    <v-card v-if="!isLoading">
      <v-card-title>
        <v-row align="center" justify="space-between" no-gutters>
          <v-col class="d-none d-md-block">
            <span class="headline no-split-words">
              {{ $t($route.meta.label) }}
            </span>
          </v-col>

          <v-col class="text-right">
            <v-btn @click="back()">
              <v-icon>arrow_back</v-icon>
              <span class="d-none d-sm-block"> {{ $t("back") }} </span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="6" class="d-flex" style="flex-direction: column">
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.id") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.id }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.refCat") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.refCat }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.heating") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.heating }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.lighting") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.lighting }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.cooling") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.cooling }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.tc") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.tc }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.constructionYear") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.constructionYear }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.ct") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.ct }}
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6" class="d-flex" style="flex-direction: column">
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.id") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.id }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.refCat") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.refCat }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.heating") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.heating }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.lighting") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.lighting }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.cooling") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.cooling }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.tc") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.tc }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.constructionYear") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.constructionYear }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.ct") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.ct }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.celda") }}:
              </v-col>
              <v-col cols="9" md="10">
                <router-link
                  :to="{
                    name: 'Celda FormDetail',
                    params: { id: entity.celda.id },
                  }"
                  v-if="entity.celda"
                >
                  {{ entity.celda.id }}
                </router-link>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6" class="d-flex" style="flex-direction: column">
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.id") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.id }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.refCat") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.refCat }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.heating") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.heating }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.lighting") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.lighting }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.cooling") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.cooling }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.use") }}:
              </v-col>
              <v-col cols="9" md="10">
                <span v-if="entity.use">
                  {{ $t(`use.${entity.use}`) }}
                </span>
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.category") }}:
              </v-col>
              <v-col cols="9" md="10">
                <span v-if="entity.category">
                  {{ $t(`category.${entity.category}`) }}
                </span>
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.floorsAbove") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.floorsAbove }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.tc") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.tc }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.gz") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.gz }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.ft") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.ft }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.wt") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.wt }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.constructionYear") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.constructionYear }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.celda") }}:
              </v-col>
              <v-col cols="9" md="10">
                <router-link
                  :to="{
                    name: 'Celda FormDetail',
                    params: { id: entity.celda.id },
                  }"
                  v-if="entity.celda"
                >
                  {{ entity.celda.id }}
                </router-link>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6" class="d-flex" style="flex-direction: column">
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.id") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.id }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.refCatastral") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.refCatastral }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.densidad") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.densidad }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.iluminacion") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.iluminacion }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.calefaccion") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.calefaccion }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.refriegeracion") }}:
              </v-col>
              <v-col cols="9" md="10">
                {{ entity.refriegeracion }}
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.uso") }}:
              </v-col>
              <v-col cols="9" md="10">
                <span v-if="entity.uso">
                  {{ $t(`uso.${entity.uso}`) }}
                </span>
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.categoria") }}:
              </v-col>
              <v-col cols="9" md="10">
                <span v-if="entity.categoria">
                  {{ $t(`categoria.${entity.categoria}`) }}
                </span>
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.celda") }}:
              </v-col>
              <v-col cols="9" md="10">
                <router-link
                  :to="{
                    name: 'Celda FormDetail',
                    params: { id: entity.celda.id },
                  }"
                  v-if="entity.celda"
                >
                  {{ entity.celda.id }}
                </router-link>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6" class="d-flex" style="flex-direction: column">
            <v-row align="center" dense>
              <v-col cols="3" md="2" class="text-left font-weight-bold">
                {{ $t("t_edificio.prop.geom") }}:
              </v-col>
              <v-col cols="9" md="10">
                <map-field
                  id="geom"
                  v-bind:entity="entity"
                  :editable="false"
                  height="400px"
                  propName="geom"
                  entityName="edificio"
                ></map-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <loading-page v-if="isLoading"></loading-page>
  </v-container>
</template>

<script>
import checkInvalidID from "@/common/checkInvalidID";

import MapField from "@/components/map-field/MapField.vue";
import LoadingPage from "@/components/loading-page/LoadingPage.vue";

import RepositoryFactory from "@/repositories/RepositoryFactory";
const EdificioEntityRepository = RepositoryFactory.get(
  "EdificioEntityRepository"
);

export default {
  name: "edificioFormDetail",
  components: { LoadingPage, MapField },
  data() {
    return {
      loading: false,
      entity: null,
    };
  },
  computed: {
    isLoading() {
      return this.loading;
    },
  },
  beforeRouteUpdate(to, from, next) {
    this._fetchData(to.params.id);
    next();
  },
  created() {
    this._fetchData(this.$route.params.id);
  },
  methods: {
    _fetchData(id) {
      this.loading = true;

      return EdificioEntityRepository.get(id)
        .then((res) => (this.entity = res))
        .catch((err) => checkInvalidID(err))
        .finally(() => (this.loading = false));
    },
    back() {
      this.$router.push({
        name: "Edificio List",
        params: { backAction: true },
      });
    },
  },
};
</script>
